// extracted by mini-css-extract-plugin
export default {"container":"AutocompleteGroup_container__DfkKU","tagContainer":"AutocompleteGroup_tagContainer__BFcFr","tagContainerGrid":"AutocompleteGroup_tagContainerGrid__Qeu+5"};